import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  const customEase = [0.16, 1, 0.3, 1];
  const pathways = [{
    number: '01',
    title: 'Masterclasses',
    description: 'Join our signature group sessions in Brisbane, Sydney, or Melbourne.',
    cta: 'View Dates →',
    href: '#masterclasses',
    featured: true
  }, {
    number: '02',
    title: 'Private Training',
    description: 'One-on-one or private group sessions tailored to your exact needs.',
    cta: 'Enquire Now →',
    href: '#private',
    featured: false
  }, {
    number: '03',
    title: 'Makeup Services',
    description: 'Professional application for bridal, formal, and special events.',
    cta: 'View Services →',
    href: '#services',
    featured: false
  }, {
    number: '04',
    title: 'Gift Vouchers',
    description: 'Give the gift of confidence with a masterclass voucher.',
    cta: 'Purchase a Voucher →',
    href: '#contact-form',
    featured: false
  }];
  return <section className="py-24 md:py-32 bg-parchment texture-grain relative overflow-hidden" data-id="element-132">
      <div className="max-w-[90rem] mx-auto px-6 lg:px-12" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        ease: customEase
      }} className="text-center mb-20 relative" data-id="element-134">
          {/* Brush Stroke Accent */}
          <svg className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[200%] text-copper opacity-[0.06] pointer-events-none" viewBox="0 0 500 200" preserveAspectRatio="none" data-id="element-135">
            <path d="M0 150 C 100 50 200 50 250 100 S 400 150 500 50" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" data-id="element-136" />
          </svg>
          <h2 className="font-serif text-5xl md:text-7xl font-light text-ink relative z-10" data-id="element-137">
            Ready to Begin?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 relative z-10" data-id="element-138">
          {pathways.map((path, index) => <motion.div key={path.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: index * 0.1,
          ease: customEase
        }} className="group flex flex-col" data-id="element-139">
              <div className="text-copper font-serif text-2xl italic mb-4" data-id="element-140">
                {path.number}
              </div>
              <h3 className="font-serif text-2xl text-ink mb-3" data-id="element-141">
                {path.title}
              </h3>
              <p className="text-stone font-sans text-sm mb-8 flex-grow" data-id="element-142">
                {path.description}
              </p>

              {path.featured ? <a href={path.href} className="inline-block bg-ink text-parchment px-8 py-3 text-xs uppercase tracking-[0.2em] hover:bg-espresso transition-colors text-center" data-id="element-143">
                  {path.cta}
                </a> : <a href={path.href} className="inline-block text-xs uppercase tracking-[0.2em] text-ink hover:text-copper transition-colors border-b border-ink hover:border-copper pb-1 w-fit" data-id="element-144">
                  {path.cta}
                </a>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}